import React from "react";
import "./Hero.css";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section id="hero" className="hero" style={{ backgroundImage: "url(hero-bg.jpg)" }}>
      <div className="hero-content">
        <h1>Bem-vindo ao Inti</h1>
        <p>Gestão financeira e crédito para micro e pequenas empresas.</p>
        <Link to="/contact" className="btn-primary">
          Fale Conosco
        </Link>
      </div>
    </section>
  );
}

export default Hero;
